import { getReportFromPath } from '@/library/HttpWebClient/api/reportloader.api.js'

const SET_REPORT = 'SET_REPORT'
const CLEAN_REPORT = 'CLEAN_REPORT'

const state = {
    Report: [],
    ReportLoading: []
}

const mutations = {
    [SET_REPORT] (state, data) {
        let _report = [...state.Report]
        _report[data.Id] = data.Html
        state.Report = _report
    },
    [CLEAN_REPORT] (state, payload) {
        let _report = [...state.Report]
        delete _report[payload]
        state.Report = _report
    }
}

const actions = {
    /*
     * Load a Report form server
     * _loadReport: {
     *   Id: unique id for report
     *   Path: api to call for loading report
     * }
     */
    async loadReport({commit}, _loadReport) {
        try {
            const response = await getReportFromPath(_loadReport.Path)
            commit(SET_REPORT, {
                Id: _loadReport.Id,
                Html: response.data,
            })
        } catch (error) {
            throw ("Error") // todo: usare il throw manager
        }
    },

    CleanReport({commit}, _cleanReport) {
        commit(CLEAN_REPORT, {
            Id: _cleanReport.Id
        })
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}